import React, { useState } from 'react';

const SquareRootTableRange = () => {
  const [startNumber, setStartNumber] = useState(10);
  const [endNumber, setEndNumber] = useState(20);
  const [squareRootTable, setSquareRootTable] = useState([]);

  const calculateSquareRootTable = () => {
    if (startNumber < 10 || endNumber > 100 || startNumber > endNumber) {
      alert("Please enter a valid range (10 to 100) and ensure the start is less than or equal to the end.");
      return;
    }

    const table = [];
    for (let i = startNumber; i <= endNumber; i++) {
      const squareRootValue = Math.sqrt(i).toFixed(4);
      table.push({ number: i, squareRootValue });
    }
    setSquareRootTable(table);
  };

  return (
    <div>
      <h2>Square Root Table Generator</h2>
      <label htmlFor="startNumber">Start Number (10-100): </label>
      <input
        type="number"
        id="startNumber"
        min="10"
        max="100"
        value={startNumber}
        onChange={(e) => setStartNumber(parseInt(e.target.value))}
      />
      <br />
      <label htmlFor="endNumber">End Number (10-100): </label>
      <input
        type="number"
        id="endNumber"
        min="10"
        max="100"
        value={endNumber}
        onChange={(e) => setEndNumber(parseInt(e.target.value))}
      />
      <br />
      <button onClick={calculateSquareRootTable}>Generate Table</button>

      {squareRootTable.length > 0 && (
        <table border="1" style={{ marginTop: '20px', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th>Number</th>
              <th>Square Root</th>
            </tr>
          </thead>
          <tbody>
            {squareRootTable.map((row, index) => (
              <tr key={index}>
                <td>{row.number}</td>
                <td>{row.squareRootValue}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default SquareRootTableRange;
